import {Fragment} from "react";

type BulkDeleteConfirmProps = {
  readonly eligibleCount: number;
  readonly userId: number;
};

const BulkDeleteConfirm = (props: BulkDeleteConfirmProps): JSX.Element => {
  const {eligibleCount, userId} = props;

  return (
    <Fragment>
      <div className="bulk-delete-confirm-note">
        <span className="bulk-delete-confirm-note-icon" aria-hidden="true">
          ⚠
        </span>
        <div>
          This permanently removes {eligibleCount.toLocaleString()} cached pages for user {userId}. Conflicts and not-found rows are
          excluded. This cannot be undone.
        </div>
      </div>
      <p className="bulk-delete-reassurance">The file is re-verified by its content hash before anything is deleted.</p>
    </Fragment>
  );
};

export default BulkDeleteConfirm;
